var map = {
	"./": [
		45649
	],
	"./amenities-filter-content": [
		70384,
		917
	],
	"./amenities-filter-content.tsx": [
		70384,
		917
	],
	"./average-rent-faq": [
		45797,
		5797
	],
	"./average-rent-faq-temp": [
		43193,
		3193
	],
	"./average-rent-faq-temp.js": [
		43193,
		3193
	],
	"./average-rent-faq.js": [
		45797,
		5797
	],
	"./city/amenities": [
		63994,
		3994
	],
	"./city/amenities.js": [
		63994,
		3994
	],
	"./city/content-template": [
		6456,
		917,
		6456
	],
	"./city/content-template.js": [
		6456,
		917,
		6456
	],
	"./city/custom/100-mile-house": [
		58691,
		917,
		6456,
		2728
	],
	"./city/custom/100-mile-house.js": [
		58691,
		917,
		6456,
		2728
	],
	"./city/custom/abbotsford": [
		74532,
		917,
		6456,
		4532
	],
	"./city/custom/abbotsford.js": [
		74532,
		917,
		6456,
		4532
	],
	"./city/custom/airdrie": [
		81105,
		917,
		6456,
		1105
	],
	"./city/custom/airdrie.js": [
		81105,
		917,
		6456,
		1105
	],
	"./city/custom/ajax": [
		6121,
		917,
		6456,
		6121
	],
	"./city/custom/ajax.js": [
		6121,
		917,
		6456,
		6121
	],
	"./city/custom/aldergrove": [
		88273,
		917,
		6456,
		8273
	],
	"./city/custom/aldergrove.js": [
		88273,
		917,
		6456,
		8273
	],
	"./city/custom/barrie": [
		56092,
		917,
		6456,
		6092
	],
	"./city/custom/barrie.js": [
		56092,
		917,
		6456,
		6092
	],
	"./city/custom/brampton": [
		54170,
		917,
		6456,
		4170
	],
	"./city/custom/brampton.js": [
		54170,
		917,
		6456,
		4170
	],
	"./city/custom/burlington-on": [
		33544,
		917,
		6456,
		3544
	],
	"./city/custom/burlington-on.js": [
		33544,
		917,
		6456,
		3544
	],
	"./city/custom/burnaby": [
		80926,
		917,
		6456,
		926
	],
	"./city/custom/burnaby.js": [
		80926,
		917,
		6456,
		926
	],
	"./city/custom/calgary": [
		89461,
		917,
		6456,
		4406
	],
	"./city/custom/calgary.js": [
		89461,
		917,
		6456,
		4406
	],
	"./city/custom/cambridge-on": [
		29090,
		917,
		6456,
		9090
	],
	"./city/custom/cambridge-on.js": [
		29090,
		917,
		6456,
		9090
	],
	"./city/custom/chilliwack": [
		84834,
		917,
		6456,
		4834
	],
	"./city/custom/chilliwack.js": [
		84834,
		917,
		6456,
		4834
	],
	"./city/custom/chipman-ab": [
		54655,
		917,
		6456,
		4655
	],
	"./city/custom/chipman-ab.js": [
		54655,
		917,
		6456,
		4655
	],
	"./city/custom/chipman-nb": [
		41898,
		917,
		6456,
		1898
	],
	"./city/custom/chipman-nb.js": [
		41898,
		917,
		6456,
		1898
	],
	"./city/custom/comox": [
		36337,
		917,
		6456,
		6337
	],
	"./city/custom/comox.js": [
		36337,
		917,
		6456,
		6337
	],
	"./city/custom/coquitlam": [
		93399,
		917,
		6456,
		3399
	],
	"./city/custom/coquitlam.js": [
		93399,
		917,
		6456,
		3399
	],
	"./city/custom/courtenay": [
		81256,
		917,
		6456,
		1256
	],
	"./city/custom/courtenay.js": [
		81256,
		917,
		6456,
		1256
	],
	"./city/custom/cowichan-valley": [
		98245,
		917,
		6456,
		8245
	],
	"./city/custom/cowichan-valley.js": [
		98245,
		917,
		6456,
		8245
	],
	"./city/custom/cranbrook": [
		8939,
		917,
		6456,
		8939
	],
	"./city/custom/cranbrook.js": [
		8939,
		917,
		6456,
		8939
	],
	"./city/custom/creston-bc": [
		70542,
		917,
		6456,
		542
	],
	"./city/custom/creston-bc.js": [
		70542,
		917,
		6456,
		542
	],
	"./city/custom/delta": [
		29501,
		917,
		6456,
		9501
	],
	"./city/custom/delta.js": [
		29501,
		917,
		6456,
		9501
	],
	"./city/custom/dorval": [
		36455,
		917,
		6456,
		6455
	],
	"./city/custom/dorval.js": [
		36455,
		917,
		6456,
		6455
	],
	"./city/custom/duncan-bc": [
		13301,
		917,
		6456,
		5606
	],
	"./city/custom/duncan-bc.js": [
		13301,
		917,
		6456,
		5606
	],
	"./city/custom/east-york": [
		41770,
		917,
		6456,
		1770
	],
	"./city/custom/east-york.js": [
		41770,
		917,
		6456,
		1770
	],
	"./city/custom/edmonton": [
		26611,
		917,
		6456,
		6611
	],
	"./city/custom/edmonton.js": [
		26611,
		917,
		6456,
		6611
	],
	"./city/custom/esquimalt": [
		8652,
		917,
		6456,
		8652
	],
	"./city/custom/esquimalt.js": [
		8652,
		917,
		6456,
		8652
	],
	"./city/custom/etobicoke": [
		52208,
		917,
		6456,
		2208
	],
	"./city/custom/etobicoke.js": [
		52208,
		917,
		6456,
		2208
	],
	"./city/custom/fernie": [
		43285,
		917,
		6456,
		3285
	],
	"./city/custom/fernie.js": [
		43285,
		917,
		6456,
		3285
	],
	"./city/custom/fort-st-john": [
		59938,
		917,
		6456,
		9938
	],
	"./city/custom/fort-st-john.js": [
		59938,
		917,
		6456,
		9938
	],
	"./city/custom/gibsons": [
		48492,
		917,
		6456,
		8492
	],
	"./city/custom/gibsons.js": [
		48492,
		917,
		6456,
		8492
	],
	"./city/custom/guelph": [
		34572,
		917,
		6456,
		4572
	],
	"./city/custom/guelph.js": [
		34572,
		917,
		6456,
		4572
	],
	"./city/custom/halifax": [
		13365,
		917,
		6456,
		3365
	],
	"./city/custom/halifax.js": [
		13365,
		917,
		6456,
		3365
	],
	"./city/custom/hamilton": [
		85141,
		917,
		6456,
		5141
	],
	"./city/custom/hamilton.js": [
		85141,
		917,
		6456,
		5141
	],
	"./city/custom/happy-valley-goose-bay": [
		83168,
		917,
		6456,
		3168
	],
	"./city/custom/happy-valley-goose-bay.js": [
		83168,
		917,
		6456,
		3168
	],
	"./city/custom/harrison-hot-springs": [
		29550,
		917,
		6456,
		9550
	],
	"./city/custom/harrison-hot-springs.js": [
		29550,
		917,
		6456,
		9550
	],
	"./city/custom/hope-bc": [
		56330,
		917,
		6456,
		6330
	],
	"./city/custom/hope-bc.js": [
		56330,
		917,
		6456,
		6330
	],
	"./city/custom/hope-qc": [
		15438,
		917,
		6456,
		5438
	],
	"./city/custom/hope-qc.js": [
		15438,
		917,
		6456,
		5438
	],
	"./city/custom/huntsville-on": [
		30499,
		917,
		6456,
		499
	],
	"./city/custom/huntsville-on.js": [
		30499,
		917,
		6456,
		499
	],
	"./city/custom/kaslo": [
		43308,
		917,
		6456,
		3308
	],
	"./city/custom/kaslo.js": [
		43308,
		917,
		6456,
		3308
	],
	"./city/custom/kelowna": [
		46266,
		917,
		6456,
		6266
	],
	"./city/custom/kelowna.js": [
		46266,
		917,
		6456,
		6266
	],
	"./city/custom/kimberley": [
		78473,
		917,
		6456,
		8473
	],
	"./city/custom/kimberley.js": [
		78473,
		917,
		6456,
		8473
	],
	"./city/custom/kingston-on": [
		81280,
		917,
		6456,
		1280
	],
	"./city/custom/kingston-on.js": [
		81280,
		917,
		6456,
		1280
	],
	"./city/custom/kitchener": [
		32777,
		917,
		6456,
		2777
	],
	"./city/custom/kitchener.js": [
		32777,
		917,
		6456,
		2777
	],
	"./city/custom/ladysmith-bc": [
		9887,
		917,
		6456,
		9887
	],
	"./city/custom/ladysmith-bc.js": [
		9887,
		917,
		6456,
		9887
	],
	"./city/custom/lake-cowichan": [
		17392,
		917,
		6456,
		7392
	],
	"./city/custom/lake-cowichan.js": [
		17392,
		917,
		6456,
		7392
	],
	"./city/custom/langley": [
		89445,
		917,
		6456,
		9445
	],
	"./city/custom/langley.js": [
		89445,
		917,
		6456,
		9445
	],
	"./city/custom/london": [
		64136,
		917,
		6456,
		4136
	],
	"./city/custom/london.js": [
		64136,
		917,
		6456,
		4136
	],
	"./city/custom/markham": [
		15665,
		917,
		6456,
		5665
	],
	"./city/custom/markham.js": [
		15665,
		917,
		6456,
		5665
	],
	"./city/custom/mississauga": [
		39808,
		917,
		6456,
		9808
	],
	"./city/custom/mississauga.js": [
		39808,
		917,
		6456,
		9808
	],
	"./city/custom/new-westminster": [
		99075,
		917,
		6456,
		9075
	],
	"./city/custom/new-westminster.js": [
		99075,
		917,
		6456,
		9075
	],
	"./city/custom/north-vancouver": [
		62874,
		917,
		6456,
		2874
	],
	"./city/custom/north-vancouver.js": [
		62874,
		917,
		6456,
		2874
	],
	"./city/custom/north-york": [
		2916,
		917,
		6456,
		2916
	],
	"./city/custom/north-york.js": [
		2916,
		917,
		6456,
		2916
	],
	"./city/custom/oshawa": [
		1559,
		917,
		6456,
		1559
	],
	"./city/custom/oshawa.js": [
		1559,
		917,
		6456,
		1559
	],
	"./city/custom/ottawa": [
		3608,
		917,
		6456,
		3608
	],
	"./city/custom/ottawa.js": [
		3608,
		917,
		6456,
		3608
	],
	"./city/custom/penticton": [
		80805,
		917,
		6456,
		805
	],
	"./city/custom/penticton.js": [
		80805,
		917,
		6456,
		805
	],
	"./city/custom/port-coquitlam": [
		60421,
		917,
		6456,
		421
	],
	"./city/custom/port-coquitlam.js": [
		60421,
		917,
		6456,
		421
	],
	"./city/custom/port-moody": [
		87836,
		917,
		6456,
		7077
	],
	"./city/custom/port-moody.js": [
		87836,
		917,
		6456,
		7077
	],
	"./city/custom/red-deer": [
		27836,
		917,
		6456,
		7836
	],
	"./city/custom/red-deer.js": [
		27836,
		917,
		6456,
		7836
	],
	"./city/custom/richmond": [
		10861,
		917,
		6456,
		861
	],
	"./city/custom/richmond-hill": [
		36079,
		917,
		6456,
		6079
	],
	"./city/custom/richmond-hill.js": [
		36079,
		917,
		6456,
		6079
	],
	"./city/custom/richmond.js": [
		10861,
		917,
		6456,
		861
	],
	"./city/custom/scarborough": [
		99194,
		917,
		6456,
		9194
	],
	"./city/custom/scarborough.js": [
		99194,
		917,
		6456,
		9194
	],
	"./city/custom/squamish": [
		66721,
		917,
		6456,
		6721
	],
	"./city/custom/squamish-lillooet": [
		12865,
		917,
		6456,
		2865
	],
	"./city/custom/squamish-lillooet.js": [
		12865,
		917,
		6456,
		2865
	],
	"./city/custom/squamish.js": [
		66721,
		917,
		6456,
		6721
	],
	"./city/custom/st-catharines": [
		50610,
		917,
		6456,
		610
	],
	"./city/custom/st-catharines.js": [
		50610,
		917,
		6456,
		610
	],
	"./city/custom/surrey": [
		56202,
		917,
		6456,
		6202
	],
	"./city/custom/surrey.js": [
		56202,
		917,
		6456,
		6202
	],
	"./city/custom/toronto": [
		85363,
		917,
		6456,
		5363
	],
	"./city/custom/toronto.js": [
		85363,
		917,
		6456,
		5363
	],
	"./city/custom/tsawwassen": [
		16953,
		917,
		6456,
		6953
	],
	"./city/custom/tsawwassen.js": [
		16953,
		917,
		6456,
		6953
	],
	"./city/custom/vancouver": [
		35415,
		917,
		6456,
		5415
	],
	"./city/custom/vancouver.js": [
		35415,
		917,
		6456,
		5415
	],
	"./city/custom/vaughan": [
		14285,
		917,
		6456,
		4285
	],
	"./city/custom/vaughan.js": [
		14285,
		917,
		6456,
		4285
	],
	"./city/custom/west-vancouver": [
		40060,
		917,
		6456,
		1185
	],
	"./city/custom/west-vancouver.js": [
		40060,
		917,
		6456,
		1185
	],
	"./city/custom/whistler": [
		69057,
		917,
		6456,
		9057
	],
	"./city/custom/whistler.js": [
		69057,
		917,
		6456,
		9057
	],
	"./city/custom/whitby": [
		17644,
		917,
		6456,
		7644
	],
	"./city/custom/whitby.js": [
		17644,
		917,
		6456,
		7644
	],
	"./city/custom/white-rock": [
		46359,
		917,
		6456,
		6359
	],
	"./city/custom/white-rock.js": [
		46359,
		917,
		6456,
		6359
	],
	"./city/custom/winnipeg": [
		94897,
		917,
		6456,
		4897
	],
	"./city/custom/winnipeg.js": [
		94897,
		917,
		6456,
		4897
	],
	"./city/custom/york": [
		92876,
		917,
		6456,
		2876
	],
	"./city/custom/york.js": [
		92876,
		917,
		6456,
		2876
	],
	"./city/generic": [
		50132,
		917,
		6456,
		132
	],
	"./city/generic/": [
		50132,
		917,
		6456,
		132
	],
	"./city/generic/canada": [
		96548,
		917,
		6456,
		6548
	],
	"./city/generic/canada.js": [
		96548,
		917,
		6456,
		6548
	],
	"./city/generic/index": [
		50132,
		917,
		6456,
		132
	],
	"./city/generic/index.js": [
		50132,
		917,
		6456,
		132
	],
	"./city/generic/usa": [
		77602,
		917,
		6456,
		7602
	],
	"./city/generic/usa.js": [
		77602,
		917,
		6456,
		7602
	],
	"./city/renting-in": [
		77040,
		7040
	],
	"./city/renting-in.js": [
		77040,
		7040
	],
	"./get-filter-links": [
		56459,
		6459
	],
	"./get-filter-links.tsx": [
		56459,
		6459
	],
	"./head": [
		54934
	],
	"./head.js": [
		54934
	],
	"./hood/amenities": [
		5918,
		5918
	],
	"./hood/amenities.js": [
		5918,
		5918
	],
	"./hood/content-template": [
		15332,
		5332
	],
	"./hood/content-template.js": [
		15332,
		5332
	],
	"./hood/custom/downtown-vancouver-vancouver": [
		83206,
		5332,
		3206
	],
	"./hood/custom/downtown-vancouver-vancouver.js": [
		83206,
		5332,
		3206
	],
	"./hood/custom/grandview-woodland-vancouver": [
		48422,
		5332,
		8422
	],
	"./hood/custom/grandview-woodland-vancouver.js": [
		48422,
		5332,
		8422
	],
	"./hood/custom/hastings-sunrise-vancouver": [
		92930,
		5332,
		2930
	],
	"./hood/custom/hastings-sunrise-vancouver.js": [
		92930,
		5332,
		2930
	],
	"./hood/custom/strathcona-vancouver": [
		80510,
		5332,
		510
	],
	"./hood/custom/strathcona-vancouver.js": [
		80510,
		5332,
		510
	],
	"./hood/custom/west-end-vancouver": [
		75217,
		5332,
		5217
	],
	"./hood/custom/west-end-vancouver.js": [
		75217,
		5332,
		5217
	],
	"./hood/generic": [
		1241,
		1241
	],
	"./hood/generic/": [
		1241,
		1241
	],
	"./hood/generic/index": [
		1241,
		1241
	],
	"./hood/generic/index.js": [
		1241,
		1241
	],
	"./index": [
		45649
	],
	"./index.tsx": [
		45649
	],
	"./poi/nearby-cities": [
		82600,
		2600
	],
	"./poi/nearby-cities.tsx": [
		82600,
		2600
	],
	"./poi/nearby-pois": [
		55512,
		5512
	],
	"./poi/nearby-pois.tsx": [
		55512,
		5512
	],
	"./poi/shopping": [
		32856,
		2856
	],
	"./poi/shopping/": [
		32856,
		2856
	],
	"./poi/shopping/index": [
		32856,
		2856
	],
	"./poi/shopping/index.js": [
		32856,
		2856
	],
	"./poi/transit/ab/calgary": [
		53607,
		3607
	],
	"./poi/transit/ab/calgary.js": [
		53607,
		3607
	],
	"./poi/transit/ab/edmonton": [
		80862,
		862
	],
	"./poi/transit/ab/edmonton.js": [
		80862,
		862
	],
	"./poi/transit/bc": [
		31028,
		1028
	],
	"./poi/transit/bc/": [
		31028,
		1028
	],
	"./poi/transit/bc/index": [
		31028,
		1028
	],
	"./poi/transit/bc/index.js": [
		31028,
		1028
	],
	"./poi/transit/on": [
		38388,
		8388
	],
	"./poi/transit/on/": [
		38388,
		8388
	],
	"./poi/transit/on/index": [
		38388,
		8388
	],
	"./poi/transit/on/index.js": [
		38388,
		8388
	],
	"./poi/transit/qc": [
		21472,
		1472
	],
	"./poi/transit/qc/": [
		21472,
		1472
	],
	"./poi/transit/qc/index": [
		21472,
		1472
	],
	"./poi/transit/qc/index.js": [
		21472,
		1472
	],
	"./popular-cities": [
		71673,
		9733
	],
	"./popular-cities.tsx": [
		71673,
		9733
	],
	"./popular-filters": [
		87509,
		7509
	],
	"./popular-filters.tsx": [
		87509,
		7509
	],
	"./popular-hoods": [
		60786,
		9884
	],
	"./popular-hoods.tsx": [
		60786,
		9884
	],
	"./popular-universities": [
		898,
		898
	],
	"./popular-universities.tsx": [
		898,
		898
	],
	"./university/average-rent": [
		40854,
		854
	],
	"./university/average-rent-temp": [
		91049,
		1049
	],
	"./university/average-rent-temp.js": [
		91049,
		1049
	],
	"./university/average-rent.js": [
		40854,
		854
	],
	"./university/content-template": [
		28332,
		8332
	],
	"./university/content-template-temp": [
		62377,
		2377
	],
	"./university/content-template-temp.js": [
		62377,
		2377
	],
	"./university/content-template.js": [
		28332,
		8332
	],
	"./university/custom/acadia-university-wolfville": [
		60813,
		8332,
		813
	],
	"./university/custom/acadia-university-wolfville.js": [
		60813,
		8332,
		813
	],
	"./university/custom/alexander-college-burnaby": [
		19469,
		8332,
		9469
	],
	"./university/custom/alexander-college-burnaby.js": [
		19469,
		8332,
		9469
	],
	"./university/custom/algoma-university-sault-ste-marie": [
		7900,
		8332,
		7900
	],
	"./university/custom/algoma-university-sault-ste-marie.js": [
		7900,
		8332,
		7900
	],
	"./university/custom/atlantic-school-of-theology-halifax": [
		49370,
		2377,
		9370
	],
	"./university/custom/atlantic-school-of-theology-halifax.js": [
		49370,
		2377,
		9370
	],
	"./university/custom/bcit-burnaby": [
		80657,
		8332,
		657
	],
	"./university/custom/bcit-burnaby.js": [
		80657,
		8332,
		657
	],
	"./university/custom/booth-university-college-winnipeg": [
		9514,
		2377,
		9514
	],
	"./university/custom/booth-university-college-winnipeg.js": [
		9514,
		2377,
		9514
	],
	"./university/custom/brock-university-st-catharines": [
		25684,
		8332,
		5684
	],
	"./university/custom/brock-university-st-catharines.js": [
		25684,
		8332,
		5684
	],
	"./university/custom/canadian-mennonite-university-winnipeg": [
		8274,
		2377,
		8274
	],
	"./university/custom/canadian-mennonite-university-winnipeg.js": [
		8274,
		2377,
		8274
	],
	"./university/custom/cape-breton-university-sydney": [
		57631,
		8332,
		7631
	],
	"./university/custom/cape-breton-university-sydney.js": [
		57631,
		8332,
		7631
	],
	"./university/custom/capilano-university-north-vancouver": [
		60506,
		8332,
		506
	],
	"./university/custom/capilano-university-north-vancouver.js": [
		60506,
		8332,
		506
	],
	"./university/custom/carleton-university-ottawa": [
		19692,
		8332,
		9692
	],
	"./university/custom/carleton-university-ottawa.js": [
		19692,
		8332,
		9692
	],
	"./university/custom/concordia-university-montreal": [
		15539,
		8332,
		5539
	],
	"./university/custom/concordia-university-montreal.js": [
		15539,
		8332,
		5539
	],
	"./university/custom/dalhousie-university-halifax": [
		54789,
		8332,
		4789
	],
	"./university/custom/dalhousie-university-halifax.js": [
		54789,
		8332,
		4789
	],
	"./university/custom/emily-carr-university-vancouver": [
		55268,
		8332,
		5268
	],
	"./university/custom/emily-carr-university-vancouver.js": [
		55268,
		8332,
		5268
	],
	"./university/custom/kpu-langley": [
		3984,
		8332,
		3984
	],
	"./university/custom/kpu-langley.js": [
		3984,
		8332,
		3984
	],
	"./university/custom/kpu-richmond": [
		30384,
		8332,
		384
	],
	"./university/custom/kpu-richmond.js": [
		30384,
		8332,
		384
	],
	"./university/custom/kpu-surrey": [
		95418,
		8332,
		5418
	],
	"./university/custom/kpu-surrey.js": [
		95418,
		8332,
		5418
	],
	"./university/custom/langara-college-vancouver": [
		53506,
		8332,
		3506
	],
	"./university/custom/langara-college-vancouver.js": [
		53506,
		8332,
		3506
	],
	"./university/custom/laurentian-university-sudbury": [
		26268,
		8332,
		7617
	],
	"./university/custom/laurentian-university-sudbury.js": [
		26268,
		8332,
		7617
	],
	"./university/custom/laval-university-quebec-city": [
		90361,
		8332,
		3603
	],
	"./university/custom/laval-university-quebec-city.js": [
		90361,
		8332,
		3603
	],
	"./university/custom/macewan-university-edmonton": [
		65894,
		8332,
		5894
	],
	"./university/custom/macewan-university-edmonton.js": [
		65894,
		8332,
		5894
	],
	"./university/custom/manitoba-institute-of-trades-technology-winnipeg": [
		57735,
		2377,
		7735
	],
	"./university/custom/manitoba-institute-of-trades-technology-winnipeg.js": [
		57735,
		2377,
		7735
	],
	"./university/custom/mcgill-university-montreal": [
		26229,
		8332,
		6229
	],
	"./university/custom/mcgill-university-montreal.js": [
		26229,
		8332,
		6229
	],
	"./university/custom/mcmaster-university-hamilton": [
		54465,
		8332,
		4465
	],
	"./university/custom/mcmaster-university-hamilton.js": [
		54465,
		8332,
		4465
	],
	"./university/custom/mount-royal-university-calgary": [
		83939,
		8332,
		4723
	],
	"./university/custom/mount-royal-university-calgary.js": [
		83939,
		8332,
		4723
	],
	"./university/custom/mount-saint-vincent-university-halifax": [
		37176,
		2377,
		7176
	],
	"./university/custom/mount-saint-vincent-university-halifax.js": [
		37176,
		2377,
		7176
	],
	"./university/custom/nipissing-university-north-bay": [
		3301,
		8332,
		3301
	],
	"./university/custom/nipissing-university-north-bay.js": [
		3301,
		8332,
		3301
	],
	"./university/custom/northeastern-university-vancouver": [
		49498,
		8332,
		9498
	],
	"./university/custom/northeastern-university-vancouver.js": [
		49498,
		8332,
		9498
	],
	"./university/custom/nova-scotia-community-college-halifax": [
		11832,
		2377,
		1832
	],
	"./university/custom/nova-scotia-community-college-halifax.js": [
		11832,
		2377,
		1832
	],
	"./university/custom/nscad-university-halifax": [
		72305,
		2377,
		2305
	],
	"./university/custom/nscad-university-halifax.js": [
		72305,
		2377,
		2305
	],
	"./university/custom/ocad-university-toronto": [
		62541,
		8332,
		2541
	],
	"./university/custom/ocad-university-toronto.js": [
		62541,
		8332,
		2541
	],
	"./university/custom/ontario-tech-university-oshawa": [
		5318,
		8332,
		5318
	],
	"./university/custom/ontario-tech-university-oshawa.js": [
		5318,
		8332,
		5318
	],
	"./university/custom/queens-university-kingston": [
		35154,
		8332,
		5154
	],
	"./university/custom/queens-university-kingston.js": [
		35154,
		8332,
		5154
	],
	"./university/custom/red-river-college-selkirk": [
		96869,
		2377,
		6869
	],
	"./university/custom/red-river-college-selkirk.js": [
		96869,
		2377,
		6869
	],
	"./university/custom/red-river-college-steinbach": [
		49882,
		2377,
		9882
	],
	"./university/custom/red-river-college-steinbach.js": [
		49882,
		2377,
		9882
	],
	"./university/custom/red-river-college-winkler": [
		28962,
		2377,
		8962
	],
	"./university/custom/red-river-college-winkler.js": [
		28962,
		2377,
		8962
	],
	"./university/custom/red-river-college-winnipeg": [
		2073,
		2377,
		2073
	],
	"./university/custom/red-river-college-winnipeg.js": [
		2073,
		2377,
		2073
	],
	"./university/custom/redeemer-university-ancaster": [
		41902,
		8332,
		6080
	],
	"./university/custom/redeemer-university-ancaster.js": [
		41902,
		8332,
		6080
	],
	"./university/custom/robertson-college-winnipeg": [
		40102,
		2377,
		102
	],
	"./university/custom/robertson-college-winnipeg.js": [
		40102,
		2377,
		102
	],
	"./university/custom/royal-roads-university-victoria": [
		22252,
		8332,
		2252
	],
	"./university/custom/royal-roads-university-victoria.js": [
		22252,
		8332,
		2252
	],
	"./university/custom/saint-marys-university-halifax": [
		95979,
		8332,
		5979
	],
	"./university/custom/saint-marys-university-halifax.js": [
		95979,
		8332,
		5979
	],
	"./university/custom/sfu-burnaby": [
		94796,
		8332,
		4796
	],
	"./university/custom/sfu-burnaby.js": [
		94796,
		8332,
		4796
	],
	"./university/custom/sfu-surrey": [
		13323,
		8332,
		3323
	],
	"./university/custom/sfu-surrey.js": [
		13323,
		8332,
		3323
	],
	"./university/custom/st-francis-xavier-university-antigonish": [
		84641,
		2377,
		4641
	],
	"./university/custom/st-francis-xavier-university-antigonish.js": [
		84641,
		2377,
		4641
	],
	"./university/custom/thompson-rivers-university-kamloops": [
		27778,
		8332,
		7778
	],
	"./university/custom/thompson-rivers-university-kamloops.js": [
		27778,
		8332,
		7778
	],
	"./university/custom/toronto-metropolitan-university-toronto": [
		57692,
		8332,
		7692
	],
	"./university/custom/toronto-metropolitan-university-toronto.js": [
		57692,
		8332,
		7692
	],
	"./university/custom/trent-university-oshawa": [
		87116,
		8332,
		5786
	],
	"./university/custom/trent-university-oshawa.js": [
		87116,
		8332,
		5786
	],
	"./university/custom/trent-university-peterborough": [
		85406,
		8332,
		5406
	],
	"./university/custom/trent-university-peterborough.js": [
		85406,
		8332,
		5406
	],
	"./university/custom/trinity-western-university-langley": [
		99180,
		8332,
		9180
	],
	"./university/custom/trinity-western-university-langley.js": [
		99180,
		8332,
		9180
	],
	"./university/custom/trinity-western-university-richmond": [
		54199,
		8332,
		4199
	],
	"./university/custom/trinity-western-university-richmond.js": [
		54199,
		8332,
		4199
	],
	"./university/custom/tyndale-university-toronto": [
		95184,
		8332,
		5184
	],
	"./university/custom/tyndale-university-toronto.js": [
		95184,
		8332,
		5184
	],
	"./university/custom/ubc-okanagan-kelowna": [
		53116,
		8332,
		3116
	],
	"./university/custom/ubc-okanagan-kelowna.js": [
		53116,
		8332,
		3116
	],
	"./university/custom/ubc-vancouver": [
		58918,
		8332,
		8918
	],
	"./university/custom/ubc-vancouver.js": [
		58918,
		8332,
		8918
	],
	"./university/custom/ufv-abbotsford": [
		43220,
		8332,
		3220
	],
	"./university/custom/ufv-abbotsford.js": [
		43220,
		8332,
		3220
	],
	"./university/custom/universite-de-saint-boniface-winnipeg": [
		58622,
		2377,
		8622
	],
	"./university/custom/universite-de-saint-boniface-winnipeg.js": [
		58622,
		2377,
		8622
	],
	"./university/custom/universite-de-sherbrooke-sherbrooke": [
		92419,
		8332,
		2419
	],
	"./university/custom/universite-de-sherbrooke-sherbrooke.js": [
		92419,
		8332,
		2419
	],
	"./university/custom/university-of-alberta-edmonton": [
		19009,
		8332,
		9009
	],
	"./university/custom/university-of-alberta-edmonton.js": [
		19009,
		8332,
		9009
	],
	"./university/custom/university-of-calgary-calgary": [
		3958,
		8332,
		3958
	],
	"./university/custom/university-of-calgary-calgary.js": [
		3958,
		8332,
		3958
	],
	"./university/custom/university-of-guelph-guelph": [
		92531,
		8332,
		2531
	],
	"./university/custom/university-of-guelph-guelph.js": [
		92531,
		8332,
		2531
	],
	"./university/custom/university-of-kings-college-halifax": [
		82333,
		2377,
		2333
	],
	"./university/custom/university-of-kings-college-halifax.js": [
		82333,
		2377,
		2333
	],
	"./university/custom/university-of-lethbridge-lethbridge": [
		77312,
		8332,
		7312
	],
	"./university/custom/university-of-lethbridge-lethbridge.js": [
		77312,
		8332,
		7312
	],
	"./university/custom/university-of-manitoba-winnipeg": [
		6590,
		8332,
		6590
	],
	"./university/custom/university-of-manitoba-winnipeg.js": [
		6590,
		8332,
		6590
	],
	"./university/custom/university-of-montreal-montreal": [
		25884,
		8332,
		5884
	],
	"./university/custom/university-of-montreal-montreal.js": [
		25884,
		8332,
		5884
	],
	"./university/custom/university-of-new-brunswick-fredericton": [
		24391,
		8332,
		4391
	],
	"./university/custom/university-of-new-brunswick-fredericton.js": [
		24391,
		8332,
		4391
	],
	"./university/custom/university-of-ottawa-ottawa": [
		98862,
		8332,
		4909
	],
	"./university/custom/university-of-ottawa-ottawa.js": [
		98862,
		8332,
		4909
	],
	"./university/custom/university-of-regina-regina": [
		5144,
		8332,
		5144
	],
	"./university/custom/university-of-regina-regina.js": [
		5144,
		8332,
		5144
	],
	"./university/custom/university-of-saskatchewan-saskatoon": [
		55502,
		8332,
		5502
	],
	"./university/custom/university-of-saskatchewan-saskatoon.js": [
		55502,
		8332,
		5502
	],
	"./university/custom/university-of-toronto-mississauga": [
		18039,
		8332,
		8039
	],
	"./university/custom/university-of-toronto-mississauga.js": [
		18039,
		8332,
		8039
	],
	"./university/custom/university-of-toronto-scarborough": [
		9757,
		8332,
		9757
	],
	"./university/custom/university-of-toronto-scarborough.js": [
		9757,
		8332,
		9757
	],
	"./university/custom/university-of-toronto-toronto": [
		81789,
		8332,
		1789
	],
	"./university/custom/university-of-toronto-toronto.js": [
		81789,
		8332,
		1789
	],
	"./university/custom/university-of-waterloo-waterloo": [
		33450,
		8332,
		3450
	],
	"./university/custom/university-of-waterloo-waterloo.js": [
		33450,
		8332,
		3450
	],
	"./university/custom/university-of-windsor-windsor-on": [
		9175,
		8332,
		9175
	],
	"./university/custom/university-of-windsor-windsor-on.js": [
		9175,
		8332,
		9175
	],
	"./university/custom/university-of-winnipeg-winnipeg": [
		62519,
		8332,
		2519
	],
	"./university/custom/university-of-winnipeg-winnipeg.js": [
		62519,
		8332,
		2519
	],
	"./university/custom/uvic-victoria": [
		56114,
		8332,
		7000
	],
	"./university/custom/uvic-victoria.js": [
		56114,
		8332,
		7000
	],
	"./university/custom/vancouver-island-university-nanaimo": [
		88054,
		8332,
		8054
	],
	"./university/custom/vancouver-island-university-nanaimo.js": [
		88054,
		8332,
		8054
	],
	"./university/custom/vcc-vancouver": [
		93058,
		8332,
		3058
	],
	"./university/custom/vcc-vancouver.js": [
		93058,
		8332,
		3058
	],
	"./university/custom/vfs-vancouver": [
		34453,
		8332,
		4453
	],
	"./university/custom/vfs-vancouver.js": [
		34453,
		8332,
		4453
	],
	"./university/custom/western-university-london": [
		74081,
		8332,
		4081
	],
	"./university/custom/western-university-london.js": [
		74081,
		8332,
		4081
	],
	"./university/custom/wilfrid-laurier-university-waterloo": [
		62174,
		8332,
		2174
	],
	"./university/custom/wilfrid-laurier-university-waterloo.js": [
		62174,
		8332,
		2174
	],
	"./university/custom/york-university-north-york": [
		3865,
		8332,
		3865
	],
	"./university/custom/york-university-north-york.js": [
		3865,
		8332,
		3865
	],
	"./university/generic": [
		3022,
		8332,
		3022
	],
	"./university/generic/": [
		3022,
		8332,
		3022
	],
	"./university/generic/index": [
		3022,
		8332,
		3022
	],
	"./university/generic/index.js": [
		3022,
		8332,
		3022
	],
	"./use-filter-slug": [
		88228
	],
	"./use-filter-slug.tsx": [
		88228
	],
	"./utils": [
		88383,
		8383
	],
	"./utils.ts": [
		88383,
		8383
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 86166;
module.exports = webpackAsyncContext;